import { Stack, Text, Wrap } from "@chakra-ui/react";
import { InterestTag } from "./InterestTag";

import { interests } from "../helpers";

export const Interests = () => (
	<Stack
		gap="2"
		rounded="6"
		py={{ md: "7" }}
		px={{ base: "4", md: "8" }}
		border={{ md: "solid 3px" }}
		borderColor={{ md: "brand.mid" }}
	>
		<Stack gap="4">
			<Text>
				One thing about me is that I love learning all about your hobbies and
				interests. It gives me so much pleasure seeing people passionate about
				things they enjoy.
			</Text>

			<Text>
				Until I get that opportunity, here's a few fun facts about me:
			</Text>
		</Stack>

		<Wrap justify="center" pt="2">
			{interests.map(({ label, additionalInfo }) => (
				<InterestTag
					additionalInfo={additionalInfo}
					label={label}
					key={label}
				/>
			))}
		</Wrap>
	</Stack>
);
